import { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { persistor, store } from 'app/store';

import type { GetValue, RootState, SetValue, UseReduxToolkit } from './types';

const useReduxToolkit: UseReduxToolkit = ({ namespace }) => {
    const dispatch = useDispatch();

    const clearStore = () => {
        persistor?.purge();
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const namespacedStore = useSelector((store: RootState) => (store as any)[namespace]);

    // Ref keeps getValue's closure pointed at the latest slice without
    // coupling its callback identity to slice updates. Stable forever;
    // downstream `useCallback([getValue])` deps never churn.
    const storeRef = useRef(namespacedStore);

    storeRef.current = namespacedStore;

    const getValue: GetValue = useCallback(type => storeRef.current[type], []);

    const setValue: SetValue = useCallback(
        keyValue => {
            const [[key, value]] = Object.entries(keyValue);

            dispatch({ payload: value, type: `${namespace}/${key}` });
        },
        [dispatch, namespace]
    );

    return {
        clear: clearStore,
        getValue,
        setValue,
        store
    };
};

export default useReduxToolkit;
